<div class="bg-primary-50 border-radius-2 border-1 border-primary-300 shadow-4 p-3 p-sm-4">
    <div class="d-flex align-items-center mb-3">
        <app-sellos [tipoOperacionCodigo]="oportunidad.tipoOperacionCodigo"></app-sellos>
        <p class="primary-900 tabs ms-2" [matTooltip]="oportunidad.alias">{{oportunidad.alias | maxCharacters:20}} •
            {{oportunidad.totalOperacionesFinanciadas}}</p>
    </div>
    <div class="d-md-flex align-items-center">
        <div class="d-flex align-items-center mb-2">
            <p class="p3-medium neutral-800">Nº operaciones financiadas:</p>
            <p class="p2-bold neutral-900 ms-2">{{oportunidad.totalOperacionesFinanciadas}}</p>
        </div>
        <div class="d-flex align-items-center mb-2 ms-md-4">
            <p class="p3-medium neutral-800">Importe total financiado:</p>
            <p class="p2-bold neutral-900 ms-2">{{oportunidad.importeTotalFinanciado | euroCurrency}}</p>
        </div>
    </div>
    <hr class="primary-300 mb-3">
    <p class="tab-ancla neutral-900 mb-3 d-md-none">Datos destacados</p>
    <div class="col-lg-9">
        <div class="d-flex align-items-center justify-content-between mb-3">
            <p class="tab-ancla neutral-900 d-none d-md-block">Datos destacados</p>
            <div class="d-md-flex align-items-center me-md-3">
                <p class="p3-medium neutral-800 mb-1 mb-md-0">Rentabilidad<sup class="font-size-10"> 1</sup></p>
                <div class="d-flex align-items-end ms-md-2">
                    <p class="p2-bold">{{oportunidad.tasaInteres}}% <span class="p3-regular"> (anual)</span></p>
                </div>
            </div>
            <div class="d-md-flex align-items-center me-md-3">
                <p class="p3-medium neutral-800 mb-1 mb-md-0">Plazo<sup class="font-size-10"> 2</sup></p>
                <p class="p2-bold ms-md-2">{{oportunidad.plazo}} días</p>
            </div>
            <div class="d-md-flex align-items-center">
                <p class="p3-medium neutral-800 mb-1 mb-md-0">Scoring<sup class="font-size-10"> 3</sup></p>
                <p class="p2-bold ms-md-2">{{oportunidad.riesgo}}</p>
            </div>
        </div>
    </div>
    <div class="row align-items-end justify-content-between">
        <div class="col-md-7">
            <p class="p2-cifras primary-900 mb-1">{{oportunidad.capitalSolicitado | euroCurrency}}</p>
            <app-progress-bar [porcientoCompletado]="oportunidad.porcientoFinanciado"></app-progress-bar>
            <p class="p3-medium neutral-900 mt-2 mb-3 mb-md-0">{{oportunidad.capitalRecaudado | euroCurrency}}
                conseguidos |
                {{oportunidad.porcientoFinanciado}}% financiado</p>
        </div>
        <div class="col-md-4">
        @if (isPlatformFactoring) {
                @if (isLogged) {
                <app-btn-link [linkType]="'routerLink'" [linkTitle]="'Ver detalles'" [linkClass]="'w-100'"
                    [linkUrl]="'/panel-inversor/' + oportunidad.operacionId"></app-btn-link>
                }@else {
                <app-btn-click [btnTitle]="'Ver detalles'" [btnClass]="'w-100'" (isBtnClicked)="openModal()"></app-btn-click>
                }
        }@else {
                @if (isLogged) {
                <app-btn-link [linkType]="'routerLink'" [linkTitle]="'Ver detalles'" [linkClass]="'w-100'" [linkType]="'href'"
                    [linkUrl]="domainUrl + '/panel-inversor/' + oportunidad.operacionId"></app-btn-link>
                }@else {
                <app-btn-click [btnTitle]="'Ver detalles'" [btnClass]="'w-100'" (isBtnClicked)="openModal()"></app-btn-click>
                }
        }
        </div>
    </div>
</div>